import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { StarIcon } from 'lucide-react';
const testimonials = [{
  quote: 'El domingo anterior no podía cenar tranquilo. Este domingo me quedé dormido en el sillón viendo una película con mis hijos. Primera vez en meses.',
  name: 'Martín G.',
  role: 'administrativo',
  location: 'Buenos Aires'
}, {
  quote: 'Pensé que era otro PDF de autoayuda. No lo es. Es un protocolo real. El lunes llegué a la oficina antes que los problemas.',
  name: 'Diego R.',
  role: 'jefe de área',
  location: 'Córdoba'
}, {
  quote: 'Mi mujer me preguntó qué me había pasado. Le dije: tres días de Reset.',
  name: 'Sebastián M.',
  role: 'contador',
  location: 'Rosario'
}];
function StarRating() {
  return <div className="flex gap-1 mb-4" data-id="element-157">
      {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-amber text-amber" data-id="element-158" />)}
    </div>;
}
export function TestimonialsSection() {
  return <section className="py-24 px-6 bg-charcoal-800" data-id="element-159">
      <div className="max-w-5xl mx-auto" data-id="element-160">
        <FadeIn data-id="element-161">
          <h2 className="font-heading text-3xl sm:text-4xl text-offwhite mb-12 text-center" data-id="element-162">
            Lo que dicen los que ya lo aplicaron
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-163">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.15 * index} data-id="element-164">
              <div className="bg-charcoal-900/50 p-8 rounded-sm border border-charcoal-700 h-full flex flex-col" data-id="element-165">
                <StarRating data-id="element-166" />
                <blockquote className="text-offwhite/90 text-lg font-light leading-relaxed mb-6 flex-1 italic" data-id="element-167">
                  "{testimonial.quote}"
                </blockquote>
                <div className="text-sm" data-id="element-168">
                  <p className="text-offwhite font-medium" data-id="element-169">
                    — {testimonial.name}
                  </p>
                  <p className="text-offwhite/60" data-id="element-170">
                    {testimonial.role}, {testimonial.location}
                  </p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}